import React, { useEffect, useState } from "react";

function CallInfo(props) {
  const [posts, setPosts] = useState([]);
 const [loginTime, setLoginTime] = useState("");
  const [readTime, setReadTime] = useState("");
  const [breakTime, setBreakTime] = useState("");
 const { agentState } = props;

  useEffect(() => {
    if (!props.loading && props.posts?.length) {
      setPosts(props.posts);

      const getValue = (key) =>
        props.posts.find((item) => item.name === key)?.value || "";

      setLoginTime(getValue("Login Time"));
      setReadTime(getValue("Free Time"));
      setBreakTime(getValue("Break Time"));
    }
  }, [props.posts, props.loading]);

  //increment function 
  const incrementTime = (time) => {
    if (!time) return time;
    const [h, m, s] = time.split(":").map(Number);
    let totalSec = h * 3600 + m * 60 + s + 1;
    const newH = String(Math.floor(totalSec / 3600)).padStart(2, "0");
    const newM = String(Math.floor((totalSec % 3600) / 60)).padStart(2, "0");
    const newS = String(totalSec % 60).padStart(2, "0");
    return `${newH}:${newM}:${newS}`;
  };


  useEffect(() => {
    const interval = setInterval(() => {
      setLoginTime((prev) => incrementTime(prev));

      if (agentState === "FREE") {
        setReadTime((prev) => incrementTime(prev));
      } else if (agentState === "BREAK") {
        setBreakTime((prev) => incrementTime(prev));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [agentState]);

  return (
    <div>
  {posts.map((post) => {
    let displayValue = post.value;

    if (post.name === "Login Time") {
      displayValue = loginTime || post.value;
    } else if (post.name === "Free Time") {
      displayValue = readTime || post.value;
    } else if (post.name === "Break Time") {
      displayValue = breakTime || post.value;
    }

    return (
      <div className="body" key={post.name}>
        <p className="name" style={{ color: "#686D88" }}>
          {post.name}
        </p>
        <p className="value">
          <b>{displayValue}</b>
        </p>
      </div>
    );
  })}
</div>
  );
}

export default CallInfo;
